var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSendemail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FEC001"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.504 10.8632C11.379 10.9101 11.1446 11.0741 11.0626 11.1718C11.0353 11.2031 10.9689 11.3163 10.9181 11.4257C10.7423 11.7851 10.7423 11.7968 11.6251 15.3241C12.0665 17.0898 12.4532 18.5741 12.4845 18.621C12.5157 18.6679 12.5743 18.7265 12.6173 18.7499C12.6603 18.7734 14.1915 18.957 16.0235 19.1601C17.8556 19.3632 19.4337 19.539 19.5274 19.5546C19.7774 19.5898 19.961 19.7773 19.961 19.9999C19.961 20.2226 19.7774 20.4101 19.5274 20.4452C19.4337 20.4609 17.8556 20.6366 16.0196 20.8398C12.6017 21.2187 12.5587 21.2265 12.4649 21.4023C12.4415 21.4413 12.0626 22.9179 11.6212 24.6835C10.7462 28.1913 10.7423 28.2109 10.9142 28.5741C11.0314 28.8281 11.1798 28.9726 11.4415 29.0937C11.6173 29.1757 11.6915 29.1874 11.9103 29.1718C12.1603 29.1523 12.4415 29.0195 20.3673 25.1523C29.2774 20.8046 28.8321 21.0429 29.0509 20.5937C29.1485 20.3984 29.1603 20.3281 29.1603 19.9999C29.1603 19.6718 29.1485 19.6015 29.0509 19.4062C28.8321 18.957 29.2774 19.1952 20.3673 14.8476L12.1681 10.8476L11.8946 10.8359C11.7462 10.8281 11.5704 10.8398 11.504 10.8632Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSendemail);
export default __webpack_public_path__ + "static/media/icon-sendemail.51dee7d3f761fce5b3156151b0d356f6.svg";
export { ForwardRef as ReactComponent };